export function toBrDate(date) {
    return date.toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export function dateCurrent() {
    return toBrDate(new Date());
}

export function firstDayMonth() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function dateFirstDayCurrent() {
    return toBrDate(firstDayMonth());
}

export function firstDayWeek() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay());
}

export function dateFirstDayWeek() {
    return toBrDate(firstDayWeek());
}

export function firstDayYear() {
    const date = new Date();
    return new Date(date.getFullYear(), 0, 1);
}

export function dateFirstDayYear() {
    return toBrDate(firstDayYear());
}